<template>
  <slot v-if="isShowRoute" />
</template>

<script setup lang="ts">
import { useRouteReloader } from '@/composition/routeReloader'

defineOptions({
  inheritAttrs: false,
})

const { isShowRoute } = useRouteReloader()
</script>
